import { cn } from '@/lib/utils'

interface GlassCardProps {
  children: React.ReactNode
  className?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export function GlassCard({ children, className, onClick }: GlassCardProps) {
  return (
    <div
      className={cn(
        "bg-glass-bg backdrop-blur-sm border border-glass-border rounded-2xl p-6",
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
